import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './tokens/fonts.css'
import './tokens/colors.css'
import './tokens/typography.css'
import './tokens/spacing.css'
import './tokens/effects.css'
import './tokens/base.css'
import './global.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
